(function () { 
  if (window.countryOptions) return;
  window.europeanCountries = {
    AT: [16.373532, 48.209137],
    BE: [4.342799, 50.85052],
    BG: [23.318705, 42.69792],
    HR: [15.974196, 45.812166],
    CY: [33.380264, 35.183442],
    CZ: [14.437258, 50.078142],
    DK: [12.431735, 55.665973],
    EE: [24.75379, 59.439569],
    FI: [24.935506, 60.173495],
    FR: [2.333696, 48.865244],
    DE: [13.40498, 52.521199],
    GR: [23.72821, 37.9846],
    HU: [19.04196, 47.498109],
    IE: [-6.259735, 53.350324],
    IT: [12.56738, 41.87194],
    LV: [24.105186, 56.94965],
    LT: [23.881275, 55.169438],
    LU: [6.129582999999999, 49.815273],
    MT: [14.514514, 35.899721],
    NL: [5.291266, 52.132633],
    PL: [21.012228, 52.229675],
    PT: [-9.139337, 38.722252],
    RO: [26.102537, 45.943161],
    SK: [19.14513, 48.70737],
    SI: [14.50583, 46.05694],
    ES: [-3.703414, 40.419467],
    SE: [18.068581, 60.128161],
    AL: [19.809499, 41.389924],
    BY: [27.564451, 53.975825],
    CH: [7.44716, 46.950139],
    GB: [-0.130058, 51.508604],
    GE: [44.827351, 41.71589],
    IS: [-21.859781, 64.099918],
    MD: [28.841543, 47.016532],
    ME: [19.259023, 42.708678],
    NO: [8.4689455, 60.472024],
    RU: [37.61667, 55.75],
    RS: [20.462222, 44.016521],
    TR: [32.854115, 39.933369],
    UA: [31.16558, 48.379433],
    XK: [20.902977, 42.6026359],
  };

  window.countryOptions = {
    ...europeanCountries,
    AF: [69.132386, 34.739287],
    AO: [13.285773, -8.748538],
    AR: [-64.388276, -31.379492],
    AE: [54.662609, 24.390891],
    AZ: [49.867851, 40.409897],
    BJ: [2.626232, 6.499347],
    BF: [-1.521672, 12.375667],
    BD: [90.410568, 23.813179],
    BS: [-73.562575, 40.655271],
    BZ: [12.849472, -4.571506],
    BM: [-86.054972, 40.038827],
    BO: [-65.25441, -19.04074],
    BR: [-47.888777, -15.791724],
    BN: [114.951828, 4.948475],
    BT: [89.647324, 27.476933],
    BW: [25.967078, -24.62583],
    CF: [18.557903, 4.396116],
    CL: [-70.693344, -33.27],
    CI: [-5.255454, 6.826119],
    CM: [11.502655, 3.852758],
    CD: [15.2495, -4.422756],
    CG: [15.240923, -4.063634],
    CO: [-74.074104, 4.715315],
    CR: [-90.871819, 14.023867],
    CU: [-82.366883, 23.119708],
    DJ: [43.146919, 11.573827],
    DO: [-69.98385, 18.50228],
    DZ: [3.058874, 36.755571],
    EC: [-78.467263, -0.179206],
    EG: [31.236287, 30.045171],
    ER: [38.925716, 15.324804],
    ET: [38.753839, 8.986474],
    FJ: [178.450079, -18.122335],
    GA: [9.495768, 0.436579],
    GH: [-0.188114, 5.604581],
    GN: [-13.577316, 9.644511],
    GM: [-16.582383, 13.457299],
    GW: [-15.619766, 11.885767],
    GQ: [8.736346, 3.749414],
    GL: [-51.573608, 64.213084],
    GT: [-90.543513, 14.649067],
    GY: [-58.140752, 6.803865],
    HN: [-87.253756, 14.044503],
    HT: [-72.307002, 18.595629],
    ID: [106.870937, -6.240893],
    IN: [77.206503, 28.62928],
    IR: [51.388399, 35.6899],
    IQ: [44.363655, 33.314606],
    IL: [34.851612, 31.046051],
    JM: [-77.297508, 18.109581],
    JO: [36.238414, 30.585164],
    JP: [138.252924, 36.204824],
    KZ: [66.923684, 48.019573],
    KE: [37.906193, -0.023559],
    KG: [74.766098, 41.20438],
    KH: [104.990963, 12.565679],
    KR: [127.0246, 37.5326],
    KW: [47.481766, 29.31166],
    LA: [102.495496, 19.85627],
    LB: [35.862285, 33.854721],
    LR: [-9.429499000000002, 6.428055],
    LY: [17.228331, 26.3351],
    LK: [80.77179699999999, 7.873053999999999],
    LS: [28.233608, -29.609988],
    MO: [113.333333, 22.198745],
    MG: [47.536097, -18.766947],
    MW: [33.783199, -13.254308],
    MY: [101.975766, 4.210484],
    ML: [-7.946527, 12.638542],
    MR: [-15.940343, 21.00789],
    MU: [57.552152, -20.348404],
    MX: [-102.552784, 23.634501],
    MN: [103.846656, 46.862496],
    MZ: [35.529562, -18.665695],
    MM: [96.19513, 21.913965],
    NA: [18.49041, -22.95764],
    NP: [84.124007, 28.394857],
    NZ: [174.885971, -40.900557],
    NI: [-85.207229, 12.865416],
    NE: [8.081666, 17.607789],
    NG: [8.675277, 9.081999],
    OM: [55.923255, 21.512572],
    PK: [73.04788, 30.375321],
    PA: [-80.782127, 8.537981],
    PE: [-77.042793, -9.189967],
    PH: [122.734195, 12.879721],
    PY: [-57.575929, -23.442503],
    QA: [51.183884, 25.354826],
    RW: [30.061923, -1.940278],
    SA: [45.079162, 24.713552],
    SD: [30.217636, 12.862807],
    SN: [-14.452362, 14.497401],
    SC: [55.491977, -4.679574],
    SL: [-13.231704, 8.460555],
    SV: [-88.89653, 13.794185],
    SO: [45.318156, 5.152149],
    SZ: [31.465866, -26.522523],
    SY: [38.996815, 34.802075],
    TD: [19.083676, 15.454166],
    TG: [1.2254, 8.619543],
    TH: [100.992541, 15.870032],
    TJ: [71.276093, 38.861034],
    TM: [58.515932, 38.969719],
    TN: [10.16579, 33.886917],
    TV: [176.133474, -7.109535],
    UG: [32.290275, 1.373333],
    UY: [-55.765835, -32.522779],
    US: [-95.712891, 37.09024],
    UZ: [64.585262, 41.377491],
    VE: [-66.58973, 6.42375],
    VN: [108.277199, 14.058324],
    YE: [48.516388, 15.552727],
    ZM: [28.331897, -15.689358],
    ZW: [31.045528, -17.8249],
    AU: [133.7751, -25.2744],
    CA: [-106.3468, 56.1304],
  };
})();
